import { toHandlers } from 'vue'

/**
 * `toHandlers`, plus Quasar 2's v-model event rename.
 *
 * The bundle's own convention is a listener map under plain names (`{ input, blur, click }`), which is
 * what a caller of a `bs-*` component binds and what every spec asserts. Quasar 2 renamed the model
 * event to `update:modelValue`, so the hand-off to the Quasar component inside has to say that
 * instead -- the mirror of `toQuasar2` in useBsComponent, which renames `value` to `modelValue`.
 *
 * Applied at the boundary rather than in the apps: several hundred templates bind `@input` on a `bs-*`
 * component, and that contract is the point of having a bundle.
 */
export function quasarHandlers (listeners?: Record<string, any>): Record<string, any> {
  const { input, ...rest } = listeners ?? {}
  const handlers = toHandlers(rest) as Record<string, any>

  return input === void 0 ? handlers : { ...handlers, ['onUpdate:modelValue']: input }
}

/**
 * The same listener map, for a PLAIN element.
 *
 * `quasarHandlers` renames `input` to Quasar 2's `update:modelValue`, which is right for a Quasar
 * component and wrong for a `<span>` or a `<div>`: the DOM event is called `input`, so the rename
 * silently detached the handler (BsChip, BsSnippet and BsClickable each stopped re-emitting).
 */
export function domHandlers (listeners?: Record<string, any>): Record<string, any> {
  return toHandlers(listeners ?? {}) as Record<string, any>
}
